<ui-sidebar-logo
  [logoUrl]="logoUrl()"
  [logoMinUrl]="logoMinUrl()"
  class="app-sidebar-logo"
  style="padding-left: 8px"
  id="kt_app_sidebar_logo"
>
</ui-sidebar-logo>

<ui-sidebar-menu
  class="app-sidebar-menu scroll-y sidebar-scroll"
  [PAGE_ROUTES]="PAGE_ROUTES()"
  [menuItems]="menuItems()"
  (lockedItemClick)="lockedItemClick.emit()"
>
</ui-sidebar-menu>
